export default __webpack_public_path__ + "images/7b607e2249addb0ff1e96fb5db7d959f-food.jpg";